import { AccountsAPI } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";

const ACCOUNT_SETTINGS_BASE = "/settings/accounts/";

export const AccountSettingKeys = {
  DISABLE_SAME_POSTING_CHECK: "disableSamePostingCheck",
};

const fetchAccountSettingsAPI = () => AccountsAPI.get(`${ACCOUNT_SETTINGS_BASE}`);

const updateAccountSettingsAPI = (data) =>
  AccountsAPI.put(`${ACCOUNT_SETTINGS_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const accountSettingsBaseService = createApplicationService({
  name: "accountSettings",
  apiFetchFn: fetchAccountSettingsAPI,
  apiUpdateFn: updateAccountSettingsAPI,
});

const accountSettingsReducer = accountSettingsBaseService.reducer;
const getAccountSettings = accountSettingsBaseService.getData;
const useAccountSettings = accountSettingsBaseService.useData;
const updateAccountSettings = accountSettingsBaseService.updateData;

const getAccountSetting = async (settingKey) => {
  const accountSettings = await getAccountSettings();
  
  if (Array.isArray(accountSettings)) {
    return accountSettings.find((s) => s.key === settingKey) ?? null;
  } else if (accountSettings && typeof accountSettings === 'object') {
    if (settingKey in accountSettings) {
      return { key: settingKey, value: accountSettings[settingKey] };
    }
    return null;
  }
  
  return null;
};

const getAccountSettingValue = async (settingKey, defaultValue = null) => {
  const accountSettings = await getAccountSettings();
  
  if (Array.isArray(accountSettings)) {
    const setting = accountSettings.find((s) => s.key === settingKey);
    return setting ? setting.value : defaultValue;
  } else if (accountSettings && typeof accountSettings === 'object') {
    return accountSettings[settingKey] ?? defaultValue;
  }
  
  return defaultValue;
};

export {
  accountSettingsReducer,
  getAccountSettings,
  useAccountSettings,
  updateAccountSettings,
  getAccountSetting,
  getAccountSettingValue,
};
